{
  "v10.primitives.liste_non_visible": "Liste non visible pour ce profil.",
  "v10.primitives.non_visible": "Non visible pour ce profil.",
  "v10.primitives.refus.titre": "Accès refusé",
  "v10.primitives.regle_indisponible": "La règle d'accès est indisponible.",
  "v10.primitives.assemblage.chargement": "Chargement des règles d’accès…",
  "v10.primitives.assemblage.erreur": "Les règles d’accès n’ont pas pu être chargées."
}
